export const MODULE = 'AUTH';
export const REQUEST = 'REQUEST';
export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';

export const KIOSKVERIFY = 'KIOSKCONFIRMPICKUP';
export const KIOSKVERIFY_REQUEST = `${MODULE}/${KIOSKVERIFY}_${REQUEST}`;
export const KIOSKVERIFY_SUCCESS = `${MODULE}/${KIOSKVERIFY}_${SUCCESS}`;
export const KIOSKVERIFY_FAILURE = `${MODULE}/${KIOSKVERIFY}_${FAILURE}`;
